import React from 'react';
import './primitives.css';

export interface CardProps {
  readonly title?: React.ReactNode;
  readonly actions?: React.ReactNode;
  readonly footer?: React.ReactNode;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly bodyClassName?: string;
  readonly 'data-testid'?: string;
}

/** SLDS-styled surface card with optional header (title + actions) and footer. */
export function Card({
  title,
  actions,
  footer,
  children,
  className,
  bodyClassName,
  ...rest
}: CardProps): React.ReactElement {
  return (
    <section className={['tl-card', className ?? ''].filter(Boolean).join(' ')} {...rest}>
      {(title || actions) && (
        <header className="tl-card__header">
          {typeof title === 'string' ? <h3 className="tl-card__title">{title}</h3> : title}
          {actions && <div>{actions}</div>}
        </header>
      )}
      <div className={['tl-card__body', bodyClassName ?? ''].filter(Boolean).join(' ')}>{children}</div>
      {footer && <footer className="tl-card__footer">{footer}</footer>}
    </section>
  );
}
